import * as z from "zod"

// Helper schema for JSON fields
type Literal = boolean | number | string
type Json = Literal | { [key: string]: Json } | Json[]
const literalSchema = z.union([z.string(), z.number(), z.boolean()])
const jsonSchema: z.ZodSchema<Json> = z.lazy(() => z.union([literalSchema, z.array(jsonSchema), z.record(z.string(), jsonSchema)]))

export const ConnectorPackageDbModel = z.object({
  id: z.string(),
  packageId: z.string(),
  packageType: z.string(),
  meta: jsonSchema,
  logoSvg: z.unknown().nullish(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})
